<h2 class="bd-title">Microsoft Teams</h2>

@if ((hasValidGroupStorageForTeams$ | async) === false) {
<alert type="warning">
  <coso-alert-message>
    You do not have group storage configured to use Microsoft Entra ID@if (!isSaaS) {
    <span> or Active Directory</span>
    }. You can configure it <a class="underline-link" routerLink="../general">here</a>.
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label id="includeMsTeamsDocumentLocationsLabel" class="cs-larger-text cs-bolder-text">Enable Microsoft Teams Support</label>
      <div id="includeMsTeamsDocumentLocationsSubLabel" class="cs-secondary-text">
        Enable Microsoft Teams support to ensure that Dynamics 365 security will be applied to files stored at related site based on linked Dynamics 365 record(s). Only available when group storage is
        set to Microsoft Entra ID@if (!isSaaS) {
        <span> or Active Directory</span>
        }.
      </div>
    </div>
    <div class="custom-control custom-switch">
      <input
        role="switch"
        type="checkbox"
        class="custom-control-input"
        id="includeMsTeamsDocumentLocations"
        name="includeMsTeamsDocumentLocations"
        aria-labelledby="includeMsTeamsDocumentLocationsLabel"
        aria-describedby="includeMsTeamsDocumentLocationsSubLabel"
        [attr.aria-checked]="settings.includeMsTeamsDocumentLocations"
        [(ngModel)]="settings.includeMsTeamsDocumentLocations"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="(readonly$ | async) || settings.groupStorage === GroupStorage.SharePoint"
      />
      <label class="custom-control-label" for="includeMsTeamsDocumentLocations">{{ settings.includeMsTeamsDocumentLocations ? "On" : "Off" }}</label>
    </div>
  </div>
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label id="appendMsTeamsDefaultPermissionsLabel" class="cs-larger-text cs-bolder-text">Append default permissions for Microsoft Teams locations</label>
      <div id="appendMsTeamsDefaultPermissionsSubLabel" class="cs-secondary-text">
        The following permissions will be added to the location linked to the team:
        <ul class="mb-0">
          <li>Team’s site Visitors: Read</li>
          <li>Team’s site Members: Edit</li>
          <li>Team’s site Owners: Full control</li>
        </ul>
        Otherwise, some users (in Teams) may not have access to files.
      </div>
    </div>
    <div class="custom-control custom-switch">
      <input
        role="switch"
        type="checkbox"
        class="custom-control-input"
        id="appendMsTeamsDefaultPermissions"
        name="appendMsTeamsDefaultPermissions"
        aria-labelledby="appendMsTeamsDefaultPermissionsLabel"
        aria-describedby="appendMsTeamsDefaultPermissionsSubLabel"
        [attr.aria-checked]="settings.appendMsTeamsDefaultPermissions"
        [(ngModel)]="settings.appendMsTeamsDefaultPermissions"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="(readonly$ | async) || !settings.includeMsTeamsDocumentLocations"
      />
      <label class="custom-control-label" for="appendMsTeamsDefaultPermissions">{{ settings.appendMsTeamsDefaultPermissions ? "On" : "Off" }}</label>
    </div>
  </div>
  }
</form>
